var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasBreadcrumbs)?_c('BreadcrumbItemList',{attrs:{"breadcrumbs":_vm.breadcrumbs}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }